import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { ActivityCollection } from '../index'

export const setupActivityReplication = (
  collection: ActivityCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'activities',
    displayName: 'Activity',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      entityType: doc.entityType,
      entityId: doc.entityId,
      activityType: doc.activityType,
      fieldName: doc.fieldName ?? null,
      description: doc.description,
      oldValue: doc.oldValue,
      newValue: doc.newValue,
      metadata: doc.metadata ?? null,
      userId: doc.createdBy,
      targetUserId: doc.targetUserId ?? null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      entityType: state.entityType,
      entityId: state.entityId,
      activityType: state.activityType,
      fieldName: state.fieldName ?? null,
      description: state.description,
      oldValue: state.oldValue,
      newValue: state.newValue,
      metadata: state.metadata ?? null,
      userId: state.userId,
      targetUserId: state.targetUserId ?? null,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
